import React from "react"
import { DadosBancariosSubcontaModel, DadosBancariosSubcontaInicial } from "../models/dadosBancariosSubcontaModel"
import { DadosBancariosSubcontaActions } from "./dadosBancariosSubcontaActions"

type DadosBancariosSubcontaContextType = {
    dados: DadosBancariosSubcontaModel
    dispatch: React.Dispatch<DadosBancariosSubcontaActions>
    erroCarregamento: string | null
    salvar: () => Promise<void>
    criar: (nomeEstabelecimento: string) => Promise<void>
}

export const DadosBancariosSubcontaContext = React.createContext<DadosBancariosSubcontaContextType>({
    dados: DadosBancariosSubcontaInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    salvar: async () => undefined,
    criar: async () => undefined,
})
